import { render, staticRenderFns } from "./RecievedPerWeekTable.vue?vue&type=template&id=23dadac7&"
import script from "./RecievedPerWeekTable.vue?vue&type=script&lang=js&"
export * from "./RecievedPerWeekTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports